__turbopack_context__.v({
  "arrow": "details-module__nGl6Za__arrow",
  "close": "details-module__nGl6Za__close",
  "content": "details-module__nGl6Za__content",
  "details": "details-module__nGl6Za__details",
  "open": "details-module__nGl6Za__open",
  "summary": "details-module__nGl6Za__summary",
});
